import React from 'react';

function AppLegalDocumentLayout({
  contact,
  docTitle,
  subtitle,
  updatedBadge,
  tocTitle,
  tocItems,
  summary,
  sections,
}) {
  const year = new Date().getFullYear();
  const { brandName, supportEmail, logoLetter } = contact;

  return (
    <div className="app-legal-doc">
      <header className="app-legal-doc__header">
        <div className="container">
          <div className="app-legal-doc__logo-mark" aria-hidden="true">
            <span className="app-legal-doc__logo-letter">{logoLetter}</span>
          </div>
          <h1 className="app-legal-doc__title">{docTitle}</h1>
          <p className="app-legal-doc__subtitle">{subtitle}</p>
          <span className="app-legal-doc__updated">{updatedBadge}</span>
        </div>
      </header>

      <div className="container">
        <nav className="app-legal-doc__toc" aria-label="Table of contents">
          <p className="app-legal-doc__toc-title">{tocTitle}</p>
          <ol className="app-legal-doc__toc-list">
            {tocItems.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`}>{item.label}</a>
              </li>
            ))}
          </ol>
        </nav>

        {summary ? (
          <div className="app-legal-doc__summary-wrap">
            <div className="app-legal-doc__highlight app-legal-doc__highlight--summary">{summary}</div>
          </div>
        ) : null}

        {sections.map((section) => (
          <section key={section.id} id={section.id} className="app-legal-doc__section">
            <div className="app-legal-doc__section-header">
              <span className="app-legal-doc__section-num">{section.num}</span>
              <h2 className="app-legal-doc__section-title">{section.title}</h2>
            </div>
            <div className="app-legal-doc__section-body">{section.body}</div>
          </section>
        ))}
      </div>

      <footer className="app-legal-doc__footer section-light-dark">
        <div className="container">
          <p>
            <span className="app-legal-doc__footer-strong">East IT Services s.r.o.</span>
            <span> · {brandName}</span>
          </p>
          <p className="app-legal-doc__footer-line">
            Questions? Write to us:{' '}
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>
          <p className="app-legal-doc__footer-copy">
            © {year} East IT Services s.r.o. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default AppLegalDocumentLayout;
